import React from 'react';
import { Form, Checkbox, Row, Col } from 'antd';

const CheckboxGroup = ({ name, label, valueName, labelName, list }) => {
  return (
    <Form.Item name={name} label={label}>
      <Checkbox.Group>
        <Row>
          {list.map(value => {
            return (
              <Col span={8}>
                <Checkbox
                  value={valueName ? value[valueName] : value}
                  style={{
                    lineHeight: '32px'
                  }}
                >
                  {labelName ? value[labelName] : value}
                </Checkbox>
              </Col>
            );
          })}
        </Row>
      </Checkbox.Group>
    </Form.Item>
  );
};

export default CheckboxGroup;
